<template>
  <div id="menu">
    <button
      class="menu-btn"
      @click="$router.push('/recos')"
      type="button"
      style="background-image: url('/static/img/iconos-menu/reco.png')"
    >
      Recos
      <span class="pending" v-if="pendings.reco > 0">{{ pendings.reco }} sin tramitar</span>
    </button>

    <button
      class="menu-btn"
      @click="$router.push('/zarpes')"
      style="background-image: url('/static/img/iconos-menu/z1.png')"
    >
      Zarpes
      <span class="pending" v-if="pendings.zarpe > 0">{{ pendings.zarpe }} sin tramitar</span>
    </button>

    <button
      class="menu-btn"
      @click="$router.push('/me')"
      style="background-image: url('/static/img/iconos-menu/multi.png')"
    >
      Multi empresas
      <span class="pending" v-if="pendings.me > 0">{{ pendings.me }} sin tramitar</span>
    </button>

    <button
      class="menu-btn"
      @click="$router.push('/rtx')"
      style="background-image: url('/static/img/iconos-menu/rtx.png')"
    >
      RTX
      <span class="pending" v-if="pendings.rtx > 0">{{ pendings.rtx }} sin tramitar</span>
    </button>

    <button
      class="menu-btn"
      @click="$router.push('/production')"
      style="background-image: url('/static/img/iconos-menu/produccion.png')"
    >
      Producción
    </button>

    <button
      class="menu-btn"
      @click="$router.push('/messages')"
      style="background-image: url('/static/img/iconos-menu/mensajeria.png')"
    >
      Mensajes
      <span class="pending" v-if="pendings.messages > 0">Total: {{ pendings.messages }}</span>
    </button>
  </div>
</template>

<script>
import http from '../http'

export default {
  name: 'Menu',
  data() {
    return {
      pendings: {
        reco: 0,
        zarpe: 0,
        me: 0,
        rtx: 0,
        messages: 0
      }
    }
  },
  created() {
    this.loadPendingData()
  },
  methods: {
    loadPendingData() {
      http.get('app/menu/services/pending')
        .then(res => {
          this.pendings = res.body
        })
        .catch(err => {
          console.error('Error loading pending data:', err)
        })
    }
  }
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// src/pages/Menu.vue